import { Component, OnInit, Input, Output, ViewChild, EventEmitter, SimpleChanges } from '@angular/core';
import { ConceptosService } from '../../../../../services/conceptos.service';
import { CuentasPorCobrarService } from '../../../../../services/cuentas-por-cobrar.service';
import { error } from 'protractor';

declare var $;

@Component({
  selector: 'app-formulario-servicio',
  templateUrl: './formulario-servicio.component.html',
  styleUrls: ['./formulario-servicio.component.scss']
})
export class FormularioServicioComponent implements OnInit {
    
  public errors: any = {};
  public periodos: any [] = [];
  public contratos: any [] = [];
  public periodicidad: any = {};
  public concepto:any={};
  public conceptos:any[]=[];
  public loading_conceptos:boolean=true;
  public loading_tipos_servicio:boolean=true;
  public tipos_servicio:any[]=[];
  public tipo_servicio:any={};

  @Output() servicioGuardado: EventEmitter<any> = new EventEmitter;
  @Input() public servicio: any = {};
  @Input() public contrato: any = {};

  constructor(public cuentasPorCobrarService:CuentasPorCobrarService) {
  }

  ngOnInit() {
    this.loadPeriodos();
    this.loadConceptos();
    this.loadTiposServicio();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.servicio && this.servicio){
      
    }
  }

  loadPeriodos(){
    let periodos = [];
    periodos.push({id: 1, descripcion: "Semanal"});
    periodos.push({id: 2, descripcion: "Quincenal"});
    periodos.push({id: 3, descripcion: "Mensual"});
    periodos.push({id: 4, descripcion: "Bimestral"});
    periodos.push({id: 5, descripcion: "Trimestral"});
    periodos.push({id: 6, descripcion: "Semestral"});
    periodos.push({id: 7, descripcion: "Anual"});

    this.periodos = periodos;
  }

  loadConceptos(){
    this.loading_conceptos = true;
    this.cuentasPorCobrarService.getAllConceptosVisiblesEnContratos()
    .subscribe(
      (response)=>{
        let content = response.json().content;
        this.conceptos = content;
        this.loading_conceptos = false;
      },
      (error)=>{
        this.loading_conceptos = false;
      }
    );
  }

  loadTiposServicio(){
    this.loading_tipos_servicio = true;
    this.cuentasPorCobrarService.getAllTiposServicio()
    .subscribe(
      (response)=>{
        let content = response.json().content;
        this.tipos_servicio = content;
        this.loading_tipos_servicio = false;
      },
      (error)=>{
        this.loading_tipos_servicio = false;
      }
    );
  }
  
  public loadServicio(servicio){
    this.servicio = servicio;

    if(this.servicio.periodicidad){
      for(var i=0;i<this.periodos.length;i++){
        var periodo = this.periodos[i];
        if(periodo.descripcion.toLowerCase()==this.servicio.periodicidad.toLowerCase()){
          this.periodicidad = periodo;
          this.changePeriodicidad(this.periodicidad);
          break;
        }
      }
    }

    if(this.servicio.id_concepto && this.servicio.id_concepto!=null && this.servicio.id_concepto!=0){
      for(var i=0;i<this.conceptos.length;i++){
        var concepto = this.conceptos[i];
        if(concepto.idConceptos==this.servicio.id_concepto){
          this.concepto = concepto;
        }
      }
    }else{
      this.concepto = {};
    }

    let component = this;
    if(this.servicio.id_tipo_servicio){
      this.tipos_servicio.forEach(tipo => {
        if(tipo.id_tipo_servicio == component.servicio.id_tipo_servicio){
          component.tipo_servicio = tipo;
        }
      });
    }

    //Si es un nuevo servicio inicializo sus valores default
    this.servicio.fecha_inicio = this.servicio.fecha_inicio ? this.servicio.fecha_inicio : 
    new Date().toISOString().slice(0,10);;
    
    

    /* if(!this.servicio.id_tipo_servicio){
      this.tipo_servicio = {};
    } */
 
  }

  public configurarFormNuevoServicio(){
    this.servicio = {
      fecha_inicio: this.contrato.fecha_inicio,
      fecha_fin: null,
      tiene_periodicidad: false
    };
    //Setup default values
    this.concepto = {};
    this.tipo_servicio = {};
    this.periodicidad = {};

    if(this.periodos.length > 0){
      this.changePeriodicidad(this.periodos[2]);
    }
  }

  public guardarServicio(){
    //Si el servicio no es periodico, no debe tener fecha fin (ya que no se necesita que tenga un rango)
    if(!this.servicio.tiene_periodicidad){
      this.servicio.fecha_fin = null;
    }

    if(!this.validar()) return false;
    //Enviar mantenimiento al padre para que la agregue a su arreglo de mantenimientos y al server
    if(this.servicioGuardado){
      this.servicioGuardado.emit(this.servicio);
    }
  }

  validar(){
    var valid = true;
    this.errors = [];
    this.errors = this.cuentasPorCobrarService.validarInfoServicio(this.servicio);
    if (!$.isEmptyObject(this.errors)) {
      valid = false;
    }
    return valid;
  }


  changePeriodicidad($event){
    this.periodicidad = $event;
    this.servicio.periodicidad = this.periodicidad.descripcion;
  }

  changeConceptoSelected($event){
    this.concepto = $event;
    this.servicio.id_concepto = this.concepto.idConceptos;
  }

  changeTipoServicioSelected($event){
    this.tipo_servicio = $event;
    this.servicio.id_tipo_servicio = this.tipo_servicio.id_tipo_servicio;
  }

  public changeEsPeriodico($event){
    //Si el servicio se marco como periododico se selecciona como fecha fin la fecha de termino del contrato
    if(this.servicio.tiene_periodicidad){
      this.servicio.fecha_fin = this.contrato.fecha_fin;
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/components/contratos/agregar-contrato/listado-servicios/formulario-servicio/formulario-servicio.component.ts